
import React, { Component } from 'react';
import WithNavigation from '../../layouts/WithNavigation';
import HomeOwnerOnboardingDashboard from '../../components/HomeOwnerDashboard/HomeOwnerOnboardingDashboard/HomeOwnerOnboardingDashboard/HomeOwnerOnboardingDashboard';

class HomeOwnerOnboardingContainer extends Component {

  render() {
    return (
        <WithNavigation
          title="Dashboard"
          border
          top={
            <HomeOwnerOnboardingDashboard
            />
          }
        />
    );
  };
}

export default HomeOwnerOnboardingContainer;
